import type { ReactNode } from "react";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/v2/tooltip";

type ActionTooltipProps = {
  tooltip: string;
  disabled: boolean;
  children: ReactNode;
};

export function ActionTooltip({ tooltip, disabled, children }: ActionTooltipProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className="inline-flex"
          tabIndex={disabled ? 0 : -1}
          aria-label={disabled ? tooltip : undefined}
        >
          {children}
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">{tooltip}</TooltipContent>
    </Tooltip>
  );
}
